export default "__VITE_ASSET__Cuzt99Q4__"